import React, { useState } from "react";
import { arrayOf, func, shape, string, number, bool } from "prop-types";
import * as style from "./styles.module.scss";

import Spinner from "../../common/Spinner";

const DownloadButton = ({ cta, handler, disabled, index }) => {
  const [loading, setLoading] = useState(false);
  return (
    <button
      disabled={loading || disabled ? "disabled" : ""}
      className={`btn btn-primary ml-auto ${index === 0 ? "" : "mt-1"}`}
      key={cta}
      onClick={async () => {
        setLoading(true);
        await handler();
        setLoading(false);
      }}
    >
      {loading ? <Spinner /> : `${cta}`}
    </button>
  );
};
DownloadButton.propTypes = {
  cta: string.isRequired,
  handler: func.isRequired,
  disabled: bool.isRequired,
  index: number,
};

const MultiResource = ({ title, description, buttons }) => (
  <div className={style.resource__wrapper}>
    <h4 className={style.resource__title}>{title}</h4>
    <p className={style.resource__description}>
      <b dangerouslySetInnerHTML={{ __html: description }} />
    </p>
    <span className="d-flex flex-column">
      {buttons.map((button, index) => (
        <DownloadButton
          key={index}
          cta={button.cta}
          handler={button.handler}
          disabled={button.disabled === true}
          index={index}
        />
      ))}
    </span>
  </div>
);

MultiResource.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  buttons: arrayOf(
    shape({
      cta: string.isRequired,
      handler: func.isRequired,
    })
  ),
};

export default MultiResource;
